import React, { useMemo, useRef, useEffect } from 'react';
import { useDroppable } from '@dnd-kit/core';

const DroppableGroup =
    ({ groupName,
        groupingKey,
        itemCount,
        isCollapsed,
        onToggleCollapse,
        children,
        selectedShapeIds,
        onShapeSelect,
        groupShapeIds, // NEW: explicit list of shape IDs in this group
        isAssemblyGrouping = false,
        assemblyData = null,
      }) => {
        const { setNodeRef, isOver } = useDroppable({
            id: `group-${groupName}`,
            data: {
                type: 'group',
                groupName: groupName,
            },
        });

        const checkboxRef = useRef(null);

        // keep last known child shape ids so checkbox still works when children are not rendered (collapsed)
        const lastChildShapeIdsRef = useRef([]);

        const childShapeIds = useMemo(() => {
            // Prefer explicit list when provided
            if (groupShapeIds && groupShapeIds.length) {
                lastChildShapeIdsRef.current = groupShapeIds;
                return groupShapeIds;
            }

            // Try to derive from children; if none (e.g. collapsed) fall back to last known list
            const idsFromChildren = React.Children
              .toArray(children)
              .flatMap(child => child.props?.shapeIds || []);

            if (idsFromChildren && idsFromChildren.length) {
                lastChildShapeIdsRef.current = idsFromChildren;
                return idsFromChildren;
            }

            return lastChildShapeIdsRef.current;
        }, [groupShapeIds, children]);

        const selectedChildrenCount = useMemo(() =>
            childShapeIds.filter(id => selectedShapeIds.includes(id)).length,
            [childShapeIds, selectedShapeIds]
        );

        const isAllSelected = childShapeIds.length > 0 && selectedChildrenCount === childShapeIds.length;
        const isPartiallySelected = selectedChildrenCount > 0 && selectedChildrenCount < childShapeIds.length;

        useEffect(() => {
            if (checkboxRef.current) {
                // Keep indeterminate controlled, but checkbox checked is controlled below via prop
                checkboxRef.current.indeterminate = isPartiallySelected;
            }
        }, [isPartiallySelected]);


        const handleGroupSelect = (e) => {
            // Use the actual checked value from the checkbox event
            const shouldSelectAll = !!e.target.checked;
            onShapeSelect(childShapeIds, shouldSelectAll);
        };

        const headerStyle = {
            cursor: 'pointer',
            padding: '0px',
            backgroundColor: isOver ? '#e0e0e0' : 'transparent', // Highlight when dragging over
            transition: 'background-color 0.2s ease',            
        };

        return (
            // Make the whole group container the droppable node for a larger hit area
            <div className="shape-group" ref={setNodeRef}>

                        <input
                            ref={checkboxRef}
                            type="checkbox"
                            id={`group-checkbox-${groupingKey}`}
                            onChange={handleGroupSelect}
                            checked={isAllSelected}
                        />
                        <span
                            onClick={onToggleCollapse}
                            style={headerStyle}
                        >
                            {isCollapsed ? '➕ ' : '➖ '}

                            <span className="group-label">
                                {/* {groupingKey}:  */}
                                {isAssemblyGrouping ? (assemblyData?.name || groupName) : groupName} ({itemCount})
                            </span>

                            {/* total measurement here */}
                        </span>

                {!isCollapsed && children}
            </div >
        );
    };

export default DroppableGroup;